/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react'
import { Route, Switch, useHistory, useLocation } from 'react-router-dom'
import { ROUTES } from '../../../utils/routes'
import { UploadImage } from './UploadImage'
import { ImageManagement } from './ImageManagement'
import { P404 } from '../../../pages'

export const MediaManagement = () => {
  const history = useHistory()
  const location = useLocation()

  return (
    <>
      <div className='flex relative justify-start space-x-10 mb-6 text-base font-semibold overflow-x-auto'>
        <div
          className={`settingTabGlobal ${
            location.pathname.search(`${ROUTES.adminPageSettingsMediaManagement}/image-management`) !== -1 &&
            'settingTabGlobalSelected'
          }`}
          onClick={() => history.push(`${ROUTES.adminPageSettingsMediaManagement}/image-management`)}
        >
          Image Management
        </div>
        <div
          className={`settingTabGlobal ${
            location.pathname.search(`${ROUTES.adminPageSettingsMediaManagement}/manual-upload`) !== -1 &&
            'settingTabGlobalSelected'
          }`}
          onClick={() => history.push(`${ROUTES.adminPageSettingsMediaManagement}/manual-upload`)}
        >
          Manual Upload
        </div>
        <div className='absolute h-px margin-l-r-0 left-0 right-0 bottom-0 bg-bluegray-300' />
      </div>
      <Switch>
        <Route
          path={[
            `${ROUTES.adminPageSettingsMediaManagement}/manual-upload`,
            `/worthy${ROUTES.adminPageSettingsMediaManagement}/manual-upload`,
          ]}
          component={UploadImage}
        />
        <Route
          path={[
            `${ROUTES.adminPageSettingsMediaManagement}/image-management`,
            `/worthy${ROUTES.adminPageSettingsMediaManagement}/image-management`,
          ]}
          component={ImageManagement}
        />
        <Route path='*' component={P404} />
      </Switch>
    </>
  )
}
